import { useSentryRouteTagging as useSentryRouteTaggingBase } from '@cast/infrastructure-monitoring';

import { getFeatureArea } from './utils';

export const useSentryRouteTagging = () =>
  useSentryRouteTaggingBase(getFeatureArea);
